<template>
    <div class="fm-container">
        <Backer />
        <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px;">Delivery Lists</div>
        <b-overlay :show="delivery_lists_being_loaded" rounded="sm">
            <div>
                <table style="width: 100%;">
                    <thead>
                        <tr style="background: black; color: white;">
                            <td class="ipt_tdhr">
                                GENERATED ON
                            </td>

                            <td class="ipt_tdhr">
                                NAME
                            </td>

                            <td class="ipt_tdhr">
                                # OF ITEMS
                            </td>

                            <td class="ipt_tdhr">
                                ACTIONS
                            </td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="delivery_list, idx in delivery_lists">
                            <td class="ipt_tdr">
                                {{ delivery_list.datetime }}
                            </td>
                            <td class="ipt_tdr">
                                {{ delivery_list.name }}
                            </td>
                            <td class="ipt_tdr">
                                {{ delivery_list.nitems }}
                            </td>
                            <td class="ipt_tdr">
                                <b-button size="sm" variant="success" @click="navigateToDeliveryList(idx)">View</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        name: "ListDeliveryLists",
        components: {Backer, VueGoodTable, Multiselect},
        data: function() {
            return {
                delivery_lists: [],
                delivery_lists_being_loaded: false,
            }
        },
        methods: {
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [];

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    prereqs[i]["executable"](path, data, s, f);
                }
            },
            fetch_init: function(){
                let that = this;
                let path = "/api/inventory/get_delivery_lists/";
                let data = {type: "st_tran"};
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.delivery_lists = response.data.result;
                    }
                    that.delivery_lists_being_loaded = false;
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading delivery lists.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.delivery_lists_being_loaded = false;
                    return
                }
                this.delivery_lists_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            navigateToDeliveryList: function(idx){
                let delivery_list = this.delivery_lists[idx];
                this.$router.push("/delivery_list/"+delivery_list.name+"/");
            },
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
                this.fetch_init();
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/ListDeliveryLists.vue